module.exports = __webpack_public_path__ + "static/media/landing-background-tab.73ca0e52.jpg";